import { protectedGet } from "./restUtil";

export function translate(args, onSuccess, onError) {
  let query =
    "text=" + encodeURIComponent(args.srcText) + "&target_lang=" + args.targetLang;
  if (args.srcLang) {
    query += "&source_lang=" + args.srcLang;
  }
  return protectedGet("/google/translation", query, onSuccess, onError);
}
